import styled from 'styled-components';
import colors from 'Styles/colors';

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.5);
`;
Overlay.displayName = 'Overlay';

export const Panel = styled.div`
  background: ${({ theme }) => theme.backgrounds.modal};
  box-shadow: ${({ theme }) => theme.boxShadow.modal};
  border-top: 6px solid ${colors.softBlue};
  border-radius: 2px;
  padding: 26px 30px;
  min-width: 360px;
  max-width: 420px;
  max-height: 70vh;
  overflow-y: auto;
`;
Panel.displayName = 'Panel';

export const Title = styled.div`
  color: ${({ theme }) => theme.text.modalTitle2};
  font-weight: 600;
  font-size: 21.5px;
  margin-bottom: 20px;
`;
Title.displayName = 'Title';

export const Section = styled.div`
  &:not(:last-child) {
    margin-bottom: 20px;
  }
`;
Section.displayName = 'Section';

export const SectionLabel = styled.div`
  font-family: 'CentraNo2';
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: ${({ theme }) => theme.text.modalDescription2};
  margin-bottom: 10px;
`;
SectionLabel.displayName = 'SectionLabel';

export const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;
List.displayName = 'List';

export const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
`;
Row.displayName = 'Row';

export const Label = styled.span`
  font-family: 'CentraNo2';
  font-size: 13px;
  color: ${({ theme }) => theme.text.modalTitle2};
`;
Label.displayName = 'Label';

export const Keys = styled.span`
  display: flex;
  align-items: center;
  gap: 6px;
  flex-shrink: 0;
`;
Keys.displayName = 'Keys';

export const Key = styled.span`
  font-family: 'CentraNo2';
  font-size: 12px;
  font-weight: 600;
  padding: 3px 8px;
  border-radius: 4px;
  background: ${({ theme }) => theme.backgrounds.tableItem};
  border: 1px solid ${({ theme }) => theme.borders.tableItem};
  box-shadow: 0 1px 0 ${({ theme }) => theme.borders.tableItem};
  color: ${({ theme }) => theme.text.modalTitle2};
  white-space: nowrap;
`;
Key.displayName = 'Key';

export const Or = styled.span`
  font-family: 'CentraNo2';
  font-size: 11px;
  color: ${({ theme }) => theme.text.modalDescription2};
`;
Or.displayName = 'Or';

export const Empty = styled.div`
  font-family: 'CentraNo2';
  font-size: 13px;
  color: ${({ theme }) => theme.text.modalDescription2};
`;
Empty.displayName = 'Empty';
